import React from 'react'
import { Link } from "react-router-dom";
const NoEventFound = () => {
    return ( 
        <div className="jumbotron">
        <h1 className="display-4">No Event Found</h1>
        <p className="lead">No Event Found</p>
            <hr className="my-4" />
        <p>
            <Link className="btn btn-primary btn-lg" to="/">Go Back</Link>
        </p>
    </div> 
     );
}
 
export default NoEventFound;